<router-outlet></router-outlet>
<markant-platform-modal></markant-platform-modal>
